import React from 'react';
import { Box, Container, Typography, Button } from '@mui/material';
import { useTranslation } from 'react-i18next'; // 1. Import hook

// --- Color Palette for this Section ---
const TEMPLE_GOLD = '#F7F2E9';
const SAFFRON_ORANGE = '#F49821';
const SAFFRON_ORANGE_HOVER = '#E08914';

const InvitationCTA = () => {
  const { t } = useTranslation(); // 2. Initialize translation function

  return (
    <Box
      component="section"
      sx={{
        backgroundColor: TEMPLE_GOLD,
        py: { xs: 8, md: 12 },
        textAlign: 'center',
      }}
    >
      <Container maxWidth="md">
        {/* Main Heading */}
        <Typography
          variant="h3"
          component="h2"
          sx={{
            fontFamily: '"Cormorant Garamond", "Georgia", serif',
            fontWeight: 700,
            lineHeight: 1.2,
            mb: 3,
            color: 'text.primary',
          }}
        >
          {t('invitation_headline')} {/* 3. Use translation */}
        </Typography>

        {/* The Invitation Paragraph */}
        <Typography
          variant="h6"
          component="p"
          sx={{
            fontFamily: '"Lato", "Helvetica", "Arial", sans-serif',
            fontWeight: 400,
            color: 'text.secondary',
            maxWidth: '700px',
            mx: 'auto',
            mb: 5,
            lineHeight: 1.8,
          }}
        >
          {t('invitation_paragraph')} {/* 3. Use translation */}
        </Typography>

        {/* The Personal Call-to-Action Button */}
        <Button
          variant="contained"
          size="large"
          href="/contact" // Link to your contact page
          sx={{
            fontFamily: '"Lato", "Helvetica", "Arial", sans-serif',
            backgroundColor: SAFFRON_ORANGE,
            color: '#111',
            fontSize: { xs: '0.9rem', sm: '1rem' },
            fontWeight: 'bold',
            letterSpacing: '1px',
            px: { xs: 3, sm: 5 },
            py: 1.5,
            borderRadius: '8px',
            boxShadow: '0 4px 15px rgba(0,0,0,0.15)',
            transition: 'background-color 0.3s ease, transform 0.2s ease, box-shadow 0.3s ease',
            '&:hover': {
              backgroundColor: SAFFRON_ORANGE_HOVER,
              transform: 'translateY(-3px)',
              boxShadow: '0 8px 25px rgba(0,0,0,0.25)',
            },
          }}
        >
          {t('invitation_button')} {/* 3. Use translation */}
        </Button>
      </Container>
    </Box>
  );
};

export default InvitationCTA;